import { render, staticRenderFns } from "./event-detail-review.vue?vue&type=template&id=a60cec96&scoped=true&"
import script from "./event-detail-review.vue?vue&type=script&lang=js&"
export * from "./event-detail-review.vue?vue&type=script&lang=js&"
import style0 from "./event-detail-review.vue?vue&type=style&index=0&id=a60cec96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60cec96",
  null
  
)

export default component.exports